<!-- 百博文章编辑 -->
<template>
  <div class="edit_comp">
    <!--
    给editor加key是因为给tinymce keep-alive以后组件切换时tinymce编辑器会显示异常，
    在activated钩子里改变key的值可以让编辑器重新创建
  -->
    标题：<el-input
      placeholder="请输入内容"
      v-model="saParamsObj.title"
      clearable
      style="width:50%;margin:10px;"
    >
    </el-input
    ><br />
    作者：
    <el-input
      v-model="saParamsObj.author"
      placeholder="请输入内容"
      style="width:10%;margin:10px;"
    ></el-input>
    文章类别：
    <el-select
      v-model="saParamsObj.newslabel"
      placeholder="请选择"
      style="margin:10px;"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <div>
      文章标签：
      <div style="width:50%;margin:20px;margin-left:80px;">
        <el-radio v-model="radio" label="1">价格管控</el-radio>
        <el-radio v-model="radio" label="2">品牌打假</el-radio>
        <el-radio v-model="radio" label="3">暗码溯源</el-radio>
        <el-radio v-model="radio" label="4">商标侵权</el-radio>
        <el-radio v-model="radio" label="5">知识维权</el-radio>
      </div>
    </div>

    <div>
      自定义标签：
      <div style="width:50%;margin:20px;margin-left:80px;">
        <el-tag
          :key="tag"
          v-for="tag in dynamicTags"
          closable
          :disable-transitions="false"
          @close="handleClose(tag)"
        >
          {{ tag }}
        </el-tag>
        <el-input
          class="input-new-tag"
          v-if="inputVisible"
          v-model="inputValue"
          ref="saveTagInput"
          size="small"
          @keyup.enter.native="handleInputConfirm"
          @blur="handleInputConfirm"
        >
        </el-input>
        <el-button v-else class="button-new-tag" size="small" @click="showInput"
          >点击添加新标签</el-button
        >
      </div>
    </div>

    文章图片：
    <el-upload
      class="avatar-uploader"
      action="https://api.bbkongjia.com/upload"
      :show-file-list="false"
      :on-success="handleAvatarSuccess"
      :before-upload="beforeAvatarUpload"
      accept="image/*"
    >
      <img v-if="imageUrl" :src="imageUrl" class="avatar" />
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <span v-if="!imageUrl" style="margin-left:90px;font-size:12px;"
      >图片大小要小于2M</span
    >
    <div>
      文章概要：<br />
      <el-input
        type="textarea"
        placeholder="请输入内容"
        v-model="saParamsObj.outline"
        style="width:50%;margin:20px 80px;"
        autosize
      >
      </el-input>
    </div>

    <!-- <Editor
      api-key="him1cspy15cwwgvibjfv6dpwajkc7gqiaoqdosm05egbwzhr"
      id="tinymceEditor"
      ref="editor"
      :init="tinymceInit"
      v-model="content"
      :key="tinymceFlag"
    ></Editor> -->
    <div style="border: 1px solid #ccc;">
      <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="editor"
        :defaultConfig="toolbarConfig"
        :mode="mode"
      />
      <Editor
        style="height: 500px; overflow-y: hidden;"
        v-model="content"
        :defaultConfig="editorConfig"
        :mode="mode"
        @onCreated="onCreated"
      />
    </div>

    <div style="margin:20px;">
      <!-- <el-button type="success" @click="saveBtn" >保存发布</el-button> -->
      <el-button type="success" @click="dyVisible = true">保存发布</el-button>
      <el-button type="danger" @click="clearBtn" style="margin-left:100px;"
        >清空内容</el-button
      >
    </div>

    <el-dialog
      title="选择发布时间"
      :visible.sync="dyVisible"
      width="400px"
      :before-close="addClose"
    >
      <el-date-picker
        v-model="saParamsObj.time"
        type="date"
        placeholder="选择发布日期"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dyVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveBtn()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import utils from "@/utils";
//引入api
import api from "@/api/index";
// import Editor from "@tinymce/tinymce-vue";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";

export default {
  name: "TinymceEditor",
  components: {
    Editor,
    Toolbar,
  },
  data() {
    return {
      radio: "1", //选择的标签
      imageUrl: "", //上传图片地址 el 显示图片用
      value: "", //文章类别
      title: "", //文章标题
      // checkList:['价格管控','品牌打假','暗码溯源','商标侵权','知识维权'],//标签，默认全部选中
      // 保存文章的参数
      saParamsObj: {
        title: "",
        outline: "", //概要
        pic: "", //图片
        content: "", //文章内容
        author: "", //作者
        label: "", //标签
        custom_label: "", //自定义标签
        newslabel: "", //文章大类别
        time: "", // 预设发布时间
      },
      options: [
        {
          //文章类别选项
          value: "1",
          label: "产品资讯",
        },
        {
          value: "2",
          label: "行业新闻",
        },
        {
          value: "3",
          label: "企业动态",
        },
      ],
      publicPath: process.env.BASE_URL,
      tinymceFlag: 1,
      tinymceInit: {
        language_url:
          "https://cdn.jsdelivr.net/gh/wt-sml/wutong_cdn/js/tinymce-lang-zh@5.2.2.js",
        language: "zh_CN",
        statusbar: false,
        height: 600,
        plugins:
          "link lists image code table colorpicker textcolor wordcount contextmenu",
        toolbar:
          "bold italic underline strikethrough | fontsizeselect | forecolor backcolor | alignleft aligncenter alignright alignjustify|bullist numlist |outdent indent blockquote | undo redo | link unlink image | removeformat",
        menubar: false, // 隐藏最上方menu
        branding: false,
        images_upload_handler: (blobInfo, success, failure) => {
          success("data:image/jpeg;base64," + blobInfo.base64());
        },
      },
      content: "",
      newId: 0, //最新的id
      headers: { "Content-Type": "multipart/form-data" },
      // 自定义标签的初始参数
      dynamicTags: [],
      inputVisible: false,
      inputValue: "", //新建标签时，里面显示的内容
      reviseData: {}, //通过修改按钮跳转过来，传递来的要修改的内容
      // 弹窗
      dyVisible: false,

      // 新富文本编辑器
      editor: null,
      html: "",
      toolbarConfig: {},
      editorConfig: {
        placeholder: "思秋，你又开始发水文了？？？",
        MENU_CONF: {
          uploadImage: {
            // 服务器端地址
            server: "https://api.bbkongjia.com/upload",
            fieldName: "file",
            allowedFileTypes: ["image/*"],
            maxFileSize: 2 * 1024 * 1024, // 2M
            customInsert: function(res, insertFn) {
              insertFn("http://www.bbkongjia.com/" + res.msg);
            },
            base64LimitSize: 5 * 1024, // 小于5kb，就会使用base64格式上传
          },
        },
      },
      mode: "default", // or 'simple'
    };
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    //文章图片
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);

      //拼成完整的路径
      this.saParamsObj.pic = res.msg;
    },
    //图片上传限制
    beforeAvatarUpload(file) {
      let isIMAGE = true;
      const isLt2M = file.size / 1024 / 1024 < 2; // 图片大小小于2M
      if (file.type != "") {
        isIMAGE =
          file.type == "image/jpeg" || "image/gif" || "image/png"
            ? true
            : false;
        // console.log(isIMAGE)
      } else {
        isIMAGE = false;
      }
      if (!isIMAGE) {
        // this.$message.error('上传文件只能是图片格式!');
        utils.notificationInfo("提示", "只能上传图片", "warning");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }

      return isIMAGE && isLt2M; //官网说明：如果返回为false，就会终止上传
    },

    sendData() {
      this.$emit("sendData", this.content);
    },

    /**
     *
     * 自定义标签的方法
     */
    handleClose(tag) {
      //删除标签
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    showInput() {
      // 点击添加时触发
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      // 添加完成后
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },

    /**
     * 清空内容
     *
     *
     * */
    clearBtn() {
      this.$confirm("此操作将清空内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.content = ""; //清空内容
          this.saParamsObj.title = ""; //标题
          this.saParamsObj.author = ""; //作者
          this.saParamsObj.newslabel = ""; //文章大类别
          this.imageUrl = "";
          this.saParamsObj.outline = ""; //概要
          this.dynamicTags = []; //自定义标签
          // console.log(111)
          utils.notificationInfo("提示", "内容已清空", "success");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },

    /**
     *
     * 保存内容  发布
     */
    saveBtn() {
      /**
       * 如果内容为空，弹出提示
       */
      if (
        this.saParamsObj.title == "" ||
        this.saParamsObj.author == "" ||
        this.saParamsObj.newslabel == "" ||
        this.imageUrl == "" ||
        this.saParamsObj.outline == "" ||
        this.content == ""
      ) {
        utils.notificationInfo("提示", "有未填内容，请检查", "warning");
      } else {
        this.saParamsObj.label = this.radio;

        //自定义标签赋值,要转为字符串
        this.saParamsObj.custom_label = this.dynamicTags.join();
        // console.log(this.saParamsObj.custom_label)
        //后端生成html文件所需代码
        this.saParamsObj.content = `
              <!DOCTYPE html>
              <html lang="en">
              <head>
                  <meta charset="UTF-8">
                  <meta name="viewport" content="width=device-width, initial-scale=1.0,minimum-scale = 1, maximum-scale = 1, user-scalable = no">
                  <title>${this.saParamsObj.title}</title>
                  <meta name="keywords" content="${this.saParamsObj.custom_label}">
                  <meta name="description" content="${this.saParamsObj.outline}">

                  <link href="../images/favicon.ico" rel="shortcut icon" />
                  <link rel="stylesheet" href="../css/base.css">
                  <link rel="stylesheet" href="../css/common.css">
                  <link rel="stylesheet" href="../css/news.css">
                  <script src="https://baiboweishi.oss-cn-beijing.aliyuncs.com/baibo_web/jquery.v3.5.1.js"><\/script>
                  <script>
                      var _hmt = _hmt || [];
                      (function() {
                        var hm = document.createElement("script");
                        hm.src = "https://hm.baidu.com/hm.js?4dac436008e70db9d73cc4b8f2dbd2c5";
                        var s = document.getElementsByTagName("script")[0];
                        s.parentNode.insertBefore(hm, s);
                      })();
                  <\/script>
              </head>
              <body>
                  <div class="header_template">
                      <div class="max-com">
                          <div class="nav_top">
                              <div class="navIcon" >
                                  <img src="../images/icon/nav_2.png" alt="">
                              </div>
                              <div class="logo">
                                  <a href="http://www.bbkongjia.com">
                                      <img src="../images/logo.png" alt="">
                                      <p>百博知识产权</p>
                                       <div class="logoTel">
                                            <p></p>
                                            <div>
                                                <p>咨询热线</p>
                                                <span>0571-87971002</span>
                                            </div>

                                        </div>
                                  </a>
                              </div>
                              <nav class="nav_list">
                                  <div class="cha"><img src="../images/icon/cha.png" alt=""></div>
                                  <ul>
                                      <li class="list_item">
                                          <a href="http://www.bbkongjia.com" target="_self" rel="noopener noreferrer">首页</a>
                                          <div class="little_box"></div>
                                      </li>
                                      <li class="list_item">
                                          <a href="http://www.bbkongjia.com/productView.html" target="_self" rel="noopener noreferrer">软件服务</a>
                                          <div class="little_box"></div>
                                      </li>
                                      <li class="list_item">
                                          <a href="http://www.bbkongjia.com/jiageguankong.html" target="_self" rel="noopener noreferrer">价格管控</a>
                                          <div class="little_box"></div>
                                      </li>

                                      <!-- <li class="list_item">
                                          <a href="#" target="_self" rel="noopener noreferrer">品牌打假</a>
                                          <div class="little_box"></div>
                                      </li> -->
                                      <li class="list_item">
                                          <a href="http://www.bbkongjia.com/anmasuyuan.html" target="_self" rel="noopener noreferrer">暗码溯源</a>
                                          <div class="little_box"></div>
                                      </li>
                                      <li class="list_item">
                                          <a href="http://www.bbkongjia.com/partner.html" target="_self" rel="noopener noreferrer">客户案例</a>
                                          <div class="little_box"></div>
                                      </li>
                                      <li class="list_item">
                                          <a href="http://www.bbkongjia.com/newsList.html" target="_self" rel="noopener noreferrer">百博资讯</a>
                                          <div class="little_box"></div>
                                      </li>
                                      <li class="list_item">
                                          <a href="http://www.bbkongjia.com/aboutus.html" target="_self">关于我们</a>
                                          <div class="little_box"></div>
                                          <div class="aboutUsBox" >
                                              <a href="http://www.bbkongjia.com/touchUs.html">联系我们</a>
                                              <a href="http://www.bbkongjia.com/joinUs.html">加入我们</a>
                                          </div>
                                      </li>
                                  </ul>
                              </nav>
                          </div>

                          <!-- <div class='mask' style="z-index:998;position: absolute;top: 0;right:-100%"></div> -->
                          <div class='mask' style="z-index:998;position: fixed;top: 0;left: 0;display: none;"></div>

                      </div>
                  </div>
                  <div class="banner">
                      <div class="banner-content bannerMob">
                          <img src="../images/news/news-banner-detail.png" alt="">

                            <p>${this.saParamsObj.title}</p>

                          <div class="banner-title">
                              <span>
                                  <a href="http://www.bbkongjia.com"> 首页 >></a>
                                  <a href="http://www.bbkongjia.com/newsList.html"> 资讯中心 >></a>
                                  <a href="#"> 行业</a>
                              </span>
                          </div>
                      </div>
                  </div>

                  <div class="detailContentPackage">
                      <div class="detailContent">
                          <div class="detailContentLeft">
                              <div class="leftTopTitle">

                              </div>
                              <div class="newsDetailsCon">
                                  ${this.content}
                              </div>
                              <div class="leftBotm">

                              </div>
                          </div>
                          <!-- 右部分 -->
                          <ul class="detialContentRight">

                          </ul>
                      </div>

                  </div>


                  <div class="relatedNews">

                  </div>


                  <div class="footer_template">
                      <div class="footer_layout">
                          <div class="footer_nav">
                              <div class="footer_advantage">
                                  <ul>
                                      <li class="advantage_items">
                                          <img src="../images/adv_01.png" alt="">
                                          <div>客户第一<br>百博价值观</div>
                                      </li>
                                      <li class="advantage_items">
                                          <img src="../images/adv_02.png" alt="">
                                          <div>行业公认<br>运营能力</div>
                                      </li>
                                      <li class="advantage_items">
                                          <img src="../images/adv_03.png" alt="">
                                          <div>专家级<br>服务团队</div>
                                      </li>
                                      <li class="advantage_items">
                                          <img src="../images/adv_04.png" alt="">
                                          <div>线下律所<br>一体化维权服务</div>
                                      </li>
                                      <li class="advantage_items">
                                          <img src="../images/adv_05.png" alt="">
                                          <div>6年全渠道保障<br>百博经验</div>
                                      </li>
                                      <li class="advantage_items">
                                          <img src="../images/adv_06.png" alt="">
                                          <div>自主知识产权的<br>软件支持</div>
                                      </li>
                                  </ul>
                              </div>
                          </div>
                          <div class="footer_contain">
                              <div class="contain_text">
                                  <div class="contact_info">
                                      <span class="tel">客户服务热线<br>0571-87971002</span>
                                      <img src="../images/wechat.png" alt="">
                                  </div>
                                  <div class="company_text">
                                      <div class="company_items">
                                          <h5>产品及服务</h5>
                                          <ul>
                                              <li class="company_items_list"><a href="">淘宝控价</a></li>
                                              <li class="company_items_list"><a href="">价格监控</a></li>
                                              <li class="company_items_list"><a href="">价格监测</a></li>
                                              <li class="company_items_list"><a href="">价格管控</a></li>
                                              <li class="company_items_list"><a href="">暗码溯源</a></li>
                                              <li class="company_items_list"><a href="">防伪溯源</a></li>
                                          </ul>
                                      </div>
                                      <div class="company_items">
                                          <h5>关于百博</h5>
                                          <ul>
                                              <li class="company_items_list"><a href="aboutus.html">公司介绍</a></li>
                                              <li class="company_items_list"><a href="partner.html">合作伙伴</a></li>
                                              <li class="company_items_list"><a href="newsList.html">企业动态</a></li>
                                              <li class="company_items_list"><a href="joinUs.html">加入我们</a></li>
                                              <li class="company_items_list"><a href="touchUs.html">联系我们</a></li>
                                          </ul>
                                      </div>
                                      <div class="company_items">
                                          <h5>电商情报</h5>
                                          <ul>
                                              <li class="company_items_list"><a href="">竞品监测</a></li>
                                              <li class="company_items_list"><a href="">电商数据分析服务</a></li>
                                              <li class="company_items_list"><a href="">电商商品和评价数据</a></li>
                                              <li class="company_items_list"><a href="">电商产品优惠底价数据监控</a></li>
                                          </ul>
                                      </div>
                                      <div class="company_items">

                                      </div>
                                  </div>
                              </div>
                          </div>
                          <!-- last -->
                          <div class="footer_foot">
                              <div class="footer_last">
                                <span>Copyright © 2015-2020  www.bbkongjia.com </span>
                                <span> <a href="https://beian.miit.gov.cn" style="font-size: 16px;color: #fff;" target="_blank">浙ICP备16040228号-6</a> </span>
                                <span>版权所有 © 杭州百博知识产权有限公司 未经许可 严禁复制</span>
                            </div>
                          </div>
                      </div>
                  </div>


                  <script src="https://baiboweishi.oss-cn-beijing.aliyuncs.com/baibo_web/news.js" > <\/script>
              </body>
              </html>
          `;

        let formData = new FormData(); //创建form对象
        formData.append("title", this.saParamsObj.title); //通过append向form对象添加数据
        formData.append("outline", this.saParamsObj.outline);
        formData.append("pic", this.saParamsObj.pic);
        formData.append("content", this.saParamsObj.content);
        formData.append("author", this.saParamsObj.author);
        formData.append("label", this.saParamsObj.label);
        formData.append("custom_label", this.saParamsObj.custom_label);
        formData.append("newslabel", this.saParamsObj.newslabel);
        formData.append("text", this.content); //新加字段，后台修改功能需要单独获取文章内容

        if (this.reviseData.id) {
          //修改文章保存api
          api.reviseArticle(formData, this.reviseData.id).then((res) => {
            console.log(res);

            utils.notificationInfo("提示", "文章上传成功", "success");

            this.$router.push({ query: {} }); //清空参数，防止重复修改
            setTimeout(() => {
              // 初始化
              this.content = ""; //清空内容
              this.saParamsObj.title = ""; //标题
              this.saParamsObj.author = ""; //作者
              this.saParamsObj.newslabel = ""; //文章大类别
              this.imageUrl = "";
              this.saParamsObj.outline = ""; //概要
              this.dynamicTags = []; //自定义标签
            }, 500);
          });
        } else {
          //调用保存文章接口
          //新建文章 保存api

          // 如果未选择发布时间，默认立即发布
          if (this.saParamsObj.time != "") {
            formData.append("time", this.saParamsObj.time);
            // console.log('定时发布')
          }
          api.saveArticle(formData).then((res) => {
            // console.log(res)
            utils.notificationInfo("提示", "文章上传成功", "success");
            this.dyVisible = false;
            //上传成功后。清空内容
            setTimeout(() => {
              // 初始化
              this.content = ""; //清空内容
              this.saParamsObj.title = ""; //标题
              this.saParamsObj.author = ""; //作者
              this.saParamsObj.newslabel = ""; //文章大类别
              this.imageUrl = "";
              this.saParamsObj.outline = ""; //概要
              this.dynamicTags = []; //自定义标签
            }, 500);
          });
        }
      }
      // console.log(this.content)
    },

    // 弹窗相关
    // 关闭弹窗确认
    addClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    dataSettle() {
      api.getSingleArticle({ id: this.reviseData.id }).then((res) => {
        let records = res.data.data.OsNews;
        //如果是修改按钮过来的，就改变默认值
        //标题
        this.saParamsObj.title = records.title;
        //作者
        this.saParamsObj.author = records.author;
        // 文章类别
        this.saParamsObj.newslabel = records.newslabel;
        // 文章标签
        this.radio = records.label;
        //自定义标签
        this.dynamicTags = records.custom_label.split(",");
        //图片
        // this.imageUrl = `https://api.bbkongjia.com/${this.reviseData.pic}`
        //概要
        this.saParamsObj.outline = records.outline;
        //内容
        this.content = records.text;
      });
    },
  },
  created() {},
  activated() {
    this.tinymceFlag++;
  },
  mounted() {
    this.onCreated();
  },
  watch: {
    $route: {
      handler: function(route) {
        this.reviseData = this.$route.query;
        // console.log(this.reviseData)
        if (this.reviseData.sign) {
          this.dataSettle();
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
};
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>

<style scoped>
.edit_comp {
  /* 思超指定杏仁黄 */
  background: #faf9de;
  padding: 20px;
}
.avatar-uploader {
  margin: 20px;
  margin-left: 80px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border-radius: 5px;
  border: 1px solid #ccc;
}
.avatar {
  width: 150px;
  height: 100px;
  display: block;
  border-radius: 5px;
}

/* 自定义标签样式 */
.el-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
